<template>
    <div class="woman-page">
        <flickity-box>
            <div class="carousel-cell" v-for="n in 6">
                <img :src="require('../assets/woman_glove_' + n +'.png')"/>
            </div>
        </flickity-box>
    </div>
</template>

<script>
  import FlickityBox from './FlickityBox';


  export default {
    components: {
      FlickityBox,
    },

    data() {
      return {
        flickityOptions: {
          freeScroll: false,
          imagesLoaded: true,
          wrapAround: true,
        },
        reloaded: false,
      };
    },

    methods: {
      layout(e) {
        if (e.isComplete && !this.reloaded) {
          this.reloaded = true;
          this.$refs.flickity.resize();
        }
      },
    },
  };

</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/WomanPage.vue